export default __webpack_public_path__ + "static/media/img_11.d80d04d7.jpg";